<mat-sidenav-container>
  <mat-sidenav #sidenav mode="side" opened class="filters medium">
    <app-form-editor #vehicleForm *ngIf="formFields" [formFieldElements]="formFields" addNewText="newVehicle"
      addModeText="addingNewVehicle" editModeText="editingVehicle"
      [allowCreateNew]="settings.shouldShowVehicleManagement()" (saveObject)="saveVehicle($event)"
      (editNew)="table.select(null)"></app-form-editor>

  </mat-sidenav>
  <mat-sidenav-content>
    <app-sidenav-toggle [sidenav]="sidenav"></app-sidenav-toggle>

    <div fxFlexFill fxLayout="column">
      <h1>{{ 'vehicleManagement' | translate }}</h1>

      <span *ngIf="loading; then showLoader else showContent"></span>

      <ng-template #showContent>

        <div class="fit-to-page">
          <app-prime-table #table remoteDataType="rest" [showPagination]="false" [sortLocally]="true" [isRandomRowHeight]="true"
            (rowClicked)="onRowSelected($event)"></app-prime-table>
        </div>

      </ng-template>
      <ng-template #showLoader>
        <mat-spinner class="center mt-20p"></mat-spinner>
      </ng-template>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>